const ALLOWED_PARAMS_REGEX_LIST = [
    /srule/,
    /prefn\d+/,
    /prefv\d+/,
    /pmin/,
    /pmax/,
    /cgid/,
];

/**
 * Returns a new URL for the current page, based on the `show more` url Params
 * @param {string} href Current `href` of the page
 * @param {string} url `Show More` url
 * @returns {string} A new URL with size parameters.
 */
export function updateURLWithSize(href, url) {
    try {
        const urlSearchParams = new URL(url).searchParams;
        const hrefObject = new URL(href);
        const hrefSearchParams = hrefObject.searchParams;
        const newSize = parseInt(urlSearchParams.get('sz'), 10) + parseInt(urlSearchParams.get('start'), 10);

        hrefSearchParams.set('start', 0);
        hrefSearchParams.set('sz', newSize);

        return hrefObject.toString();
    } catch (error) {
        return href;
    }
}

/**
 * Returns a new URL for the current page, based on the `filter` url Params
 * @param {string} href Current `href` of the page
 * @param {string} url `Filter` url
 * @returns {string} A new URL with filters parameters.
 */
export function updateURLWithFilters(href, url) {
    try {
        const urlSearchParams = new URL(url, window.location.origin).searchParams;
        const hrefObject = new URL(href);
        const hrefSearchParams = hrefObject.searchParams;
        const urlParamKeys = Array.from(urlSearchParams.keys());
        const hrefParamKeys = Array.from(hrefSearchParams.keys());

        hrefParamKeys.forEach((key) => {
            const isAlsoInFilterUrl = urlParamKeys.includes(key);
            if (!isAlsoInFilterUrl) {
                hrefSearchParams.delete(key);
            }
        });

        urlParamKeys.forEach((key) => {
            const isAllowed = ALLOWED_PARAMS_REGEX_LIST.some((rx) => rx.test(key));
            if (isAllowed) {
                hrefSearchParams.set(key, urlSearchParams.get(key));
            }
        });

        return hrefObject.toString();
    } catch (error) {
        return href;
    }
}
